export * from './bet-token.service';

import { BetTokenService } from './bet-token.service';

export const PROVIDERS = [
  BetTokenService,
];



// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/src/app/shared/index.ts